import { AnchorWallet } from "@solana/wallet-adapter-react";
import { Connection, Keypair, PublicKey } from "@solana/web3.js";
import { AnchorProvider, Program } from "@project-serum/anchor";
import { IDL } from "../club_program_develop";
import { IDL as ESCROW_IDL } from "../escrow_program";
import { IDL as UNIVERSE_IDL } from "../universe_program";
import { IDL as UDM_IDL } from "../udm_program";
import NodeWallet from "@project-serum/anchor/dist/cjs/nodewallet";
import { hash } from "@project-serum/anchor/dist/cjs/utils/sha256";

const SECRET_KEY_ARRAY = [
  165, 112, 248, 153, 73, 228, 179, 91, 59, 251, 97, 251, 131, 190, 126, 136,
  53, 56, 152, 125, 179, 15, 248, 103, 15, 112, 151, 40, 158, 100, 142, 118,
  239, 251, 12, 66, 156, 162, 168, 29, 205, 233, 192, 137, 43, 36, 140, 158,
  240, 6, 103, 113, 43, 187, 2, 120, 54, 179, 200, 6, 107, 80, 116, 144,
];

export const UDM_PROGRAM_ID = "FG82Bh2yS5dcydGXk2PCkZb3sEZdcDTXPJhQQ83kDK1n";

export const SOLANA_PROGRAM_ID = process.env
  .REACT_APP_BLOCKCHAIN_CLUB_PROGRAM_ID as string;

export const UNIVERSE_PROGRAM_ID = process.env
  .REACT_APP_BLOCKCHAIN_UNIVERSE_PROGRAM_ID as string;

//TODO@milica: add to env if we decided to use quick node
export const QUICK_NODE_DEVNET_ENDPOINT =
  "https://fluent-wispy-pool.solana-devnet.quiknode.pro/1c6712e18189249c0280021a7c25fa5900cf2916/";
export const QUICK_NODE_MAINNET_ENDPOINT =
  "https://dry-cosmological-pool.solana-mainnet.quiknode.pro/e2650ac4ff2395af0262c730666ef3b1064037ce/";

export const SOLANA_ENDPOINT = process.env
  .REACT_APP_BLOCKCHAIN_NETWORK_URL as string;
export const SECRET_KEY = Uint8Array.from(SECRET_KEY_ARRAY);
export const keypair = Keypair.fromSecretKey(SECRET_KEY);
export const RPC_CONNECTION = new Connection(SOLANA_ENDPOINT, "confirmed");

export const REACT_APP_FRONT_BASE_URL = process.env
  .REACT_APP_FRONT_BASE_URL as string;

export const SOLSEA_URL = process.env.REACT_APP_SOLSEA_URL as string;
export const CIVIC_NON_US = process.env.REACT_APP_CIVIC_NON_US as string;
export const CIVIC_US = process.env.REACT_APP_CIVIC_US as string;
export const programFactory = (wallet?: AnchorWallet) => {
  return new Program(
    IDL,
    SOLANA_PROGRAM_ID,
    new AnchorProvider(RPC_CONNECTION, wallet ?? new NodeWallet(keypair), {})
  );
};

export const udmProgramFactory = (wallet?: AnchorWallet) => {
  return new Program(
    UDM_IDL,
    UDM_PROGRAM_ID,
    new AnchorProvider(RPC_CONNECTION, wallet ?? new NodeWallet(keypair), {})
  );
};

export const UNQ_SPL_GOVERNANCE_PROGRAM_ID = process.env
  .REACT_APP_BLOCKCHAIN_GOVERNANCE_PROGRAM_ID as string;

export const MAIN_SPL_GOVERNANCE_PROGRAM_ID = process.env
  .REACT_APP_BLOCKCHAIN_MAIN_SPL_GOVERNANCE_PROGRAM_ID as string;

export const MINT_KEY = "UNQtEecZ5Zb4gSSVHCAWUQEoNnSVEbWiKCi1v9kdUJJ";
//TODO@milica-monke-merge: Monke mint is only for monke
export const MONKE_MINT = process.env.REACT_APP_MONKE_MINT as string;
export const USDC_KEY = process.env.REACT_APP_BLOCKCHAIN_USDC_MINT as string;
export const USDT_KEY = process.env.REACT_APP_BLOCKCHAIN_USDT_MINT as string;

export const METADATA_PROGRAM_ID = new PublicKey(
  "metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s"
);
export const ESCRROW_PROGRAM = new PublicKey(
  process.env.REACT_APP_BLOCKCHAIN_ESCROW_PROGRAM_ID as string
);

export const solseaProgram = new PublicKey(
  "AARTcKUzLYaWmK7D1otgyAoFn5vQqBiTrxjwrvjvsVJa"
);

export const solseaProfitAccount = new PublicKey(
  "6T4f5bdrd9ffTtehqAj9BGyxahysRGcaUZeDzA1XN52N"
);

export const escrowProgramFactory = (wallet?: AnchorWallet) => {
  return new Program(
    ESCROW_IDL,
    ESCRROW_PROGRAM,
    new AnchorProvider(RPC_CONNECTION, wallet ?? new NodeWallet(keypair), {})
  );
};

export const universeProgramFactory = (wallet?: AnchorWallet) => {
  return new Program(
    UNIVERSE_IDL,
    UNIVERSE_PROGRAM_ID,
    new AnchorProvider(RPC_CONNECTION, wallet ?? new NodeWallet(keypair), {})
  );
};

export const initializeEscrowHash = hash("global:initialize_escrow").slice(
  0,
  16
);
export const initializeMEEscrowHash = hash(
  "global:initalize_me_buy_offer"
).slice(0, 16);

export const initializeMESellEscrowHash = hash(
  "global:initalize_me_sell_offer"
).slice(0, 16);

export const initializeWithdrawalHash = hash(
  "global:initialize_withdrawal"
).slice(0, 16);

export const initializeUnqMarkeplaceHash = hash(
  "global:initialize_unq_marketplace"
).slice(0, 16);

export const transferFundsHash = hash("global:transfer_funds").slice(0, 16);

export const governanceSeed = Buffer.from("governance");
export const treasurySeed = Buffer.from("treasury");
export const unqClubSeed = Buffer.from("unq-club");
export const realmConfigSeed = Buffer.from("realm-config");
export const unqClubMemberSeed = Buffer.from("member");
export const voterWeightSeed = Buffer.from("voter-weight-record");
export const accountGovernanceSeed = Buffer.from("account-governance");
export const treasuryDataSeed = Buffer.from("treasury-data");
export const vaultSeed = Buffer.from("vault");
export const vaultDataSeed = Buffer.from("vault-data");
export const fundraiseCfgSeed = Buffer.from("fundraise-cfg");
export const depositRecordSeed = Buffer.from("deposit-record");
export const maxVoterWeightSeed = Buffer.from("max-voter-weight-record");
export const offerSeed = Buffer.from("offer");
export const escrowSeed = Buffer.from("escrowed-tokens");
export const proposalMetadataSeed = Buffer.from("proposal-metadata");
export const sellPermissionGovernanceSeed = Buffer.from("spc-governance");
export const profitSeed = Buffer.from("profit");
export const transferProfitSeed = Buffer.from("transfer-profit");
export const acceptOfferSeed = Buffer.from("accepted-offer");
export const nftVoteRecordSeed = Buffer.from("nft-vote-record");
export const tokenLedgerSeed = Buffer.from("token-ledger");
export const withdrawalSeed = Buffer.from("withdrawal");
export const withdrawalDataSeed = Buffer.from("withdrawal-data");
export const withdrawalRecordSeed = Buffer.from("withdrawal-record");
export const financialRecordSeed = Buffer.from("financial-record");
export const changeClubConfigGovernance = Buffer.from(
  "governance-change-governance"
);
export const stakeConfigSeed = Buffer.from("stake-config");
export const stakedTokensSeed = Buffer.from("staked-tokens");
export const stakeRecordSeed = Buffer.from("stake-record");
export const unqTokensSeed = Buffer.from("club-program-unq-tokens");
export const metadataSeed = Buffer.from("metadata");
export const buyNowMagicEdenAccounts = Buffer.from("buy-now-accounts");
export const stakedNftSeed = Buffer.from("staked-nft");
export const universeMetadataSeed = Buffer.from("universe");
export const magicEdenSeed = Buffer.from("magic-eden");
export const denominatedTokenSeed = Buffer.from("denominated-token");
export const financialOfferSeed = Buffer.from("financial-offer");
export const monkeAuthoritySeed = Buffer.from("monke-authority");
export const monkeAdminSeed = Buffer.from("monke-admin");
export const transferSeed = Buffer.from("transfer-governance");

export const splGovernanceProgram = new PublicKey(
  UNQ_SPL_GOVERNANCE_PROGRAM_ID
);
export const mainSplGovProgram = new PublicKey(MAIN_SPL_GOVERNANCE_PROGRAM_ID);
export const mint: PublicKey = new PublicKey(MINT_KEY);
export const monkeMint: PublicKey = new PublicKey(MONKE_MINT);
export const usdcMint: PublicKey = new PublicKey(USDC_KEY);
export const usdtMint: PublicKey = new PublicKey(USDT_KEY);
export const auctionHouseAddressKey =
  "E8cU1WiRWjanGxmn96ewBgk9vPTcL6AEZ1t6F6fkgUWe";

export const magicEden = new PublicKey(
  "M2mx93ekt1fmXSVkTrUL9xVFHkmME8HTUi5Cyc5aF7K"
);

export const solanaApiLogo =
  "https://assets.coingecko.com/coins/images/21629/large/solana.jpg?1639626543";

export const tokenListApi = "https://token-list-api.solana.cloud/v1/mints";

//TODO@milica-monke-merge: update addresses when Monke send them
export const createClubWalletsArray = [
  new PublicKey("3rxQ9vCeFSeckmLda9gnfY21JTL6FYWaRnqAARwKNBLx"),
  new PublicKey("EATtn5dRyHxHFFEK7cZ5ZDG4qDPD29d1npjD3nF7DQcM"),
];
//TODO@milica-monke-merge
export const shouldCheckCreateClubWallets = false;
